import { render } from "./AdminUsers.vue?vue&type=template&id=99d99b34&scoped=true"
import script from "./AdminUsers.vue?vue&type=script&lang=js"
export * from "./AdminUsers.vue?vue&type=script&lang=js"

import "./AdminUsers.vue?vue&type=style&index=0&id=99d99b34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99d99b34"]])

export default __exports__